<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Colaboradores</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold m-0"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold mr-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold ml-0"
                v-b-tooltip.hover
                title="Descargar"
                @click="downloadReport()"
              >
                <i class="ri-download-2-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto md-flex-1 d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre o número de documento"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'employee-bulk-upload' }"
                  variant="none"
                  class="button button-light ml-md-2"
                ><i class="ri-upload-2-line mr-1"></i>Cargar</b-button>
                <b-button
                  :to="{ name: 'employee-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Código de colaborador</span>
            </div>

            <div>
              <span>Nombre Completo</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.code }}</span>
                </div>

                <div>
                  <span>{{ o.fullName || '-' }}</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'employee-details', params: { id: o.id } }"
                >
                  Ver detalle
                </router-link>

                <router-link
                  :to="{ name: 'employee-edit', params: { id: o.id } }"
                  class="mx-3"
                >
                  Editar
                </router-link>

                <!-- <a href="" @click.prevent="openChangeStatus(o)">
                  {{ getStatus(o.status).action }}
                </a> -->
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Empresa:</span
                    >
                    <span class="text-uppercase">{{ companies(o) }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Área:</span
                    >
                    <span>{{ areas(o) }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Cargo:</span
                    >
                    <span>{{ positions(o) }}</span>
                  </li>


                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                      getStatus(o.status).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Código de colaborador</th>
              <th>Nombre Completo</th>
              <th>Empresa</th>
              <th>Área</th>
              <th>Cargo</th>
              <!-- <th>Días Pendientes <br> de Vacaciones</th> -->
              <th>Estado</th>
              <th>Docs</th>
              <th class="pr-md-3">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center pl-3">{{ o.code }}</td>
              <td>{{ o.fullName || '-' }}</td>
              <td :class="{'cell-center': !companies(o)}" class="text-uppercase">{{ companies(o) }}</td>
              <td :class="{'cell-center': !areas(o)}">{{ areas(o) }}</td>
              <td :class="{'cell-center': !positions(o)}">{{ positions(o) }}</td>
              <td class="cell-center pl-md-2">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="cell-center pl-md-2">
                <i v-if="o.documentationComplete"
                   class="ri-checkbox-circle-line text-success"
                   style="font-size: 1.25rem;"
                   v-b-tooltip.hover
                   title="Documentación completa"></i>
                <i v-else
                   class="ri-error-warning-line text-warning"
                   style="font-size: 1.25rem;"
                   v-b-tooltip.hover
                   title="Faltan documentos obligatorios"></i>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      text="Ver detalle"
                      :to="{
                        name: 'employee-details',
                        params: { id: o.id },
                      }"
                    />
                    <DropdownItem
                      text="Editar"
                      :to="{
                        name: 'employee-edit',
                        params: { id: o.id },
                      }"
                    />
                    <!-- <DropdownItem
                      :text="getStatus(o.status).action"
                      @click="openChangeStatus(o.id, EmployeeStatus.INACTIVE.key)"
                    /> -->
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Constants,
  Util,
  Alert,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";
import { EmployeeService, AreaService, RolesService, CompanyService } from "@/core/services";
// import fileDownload from "js-file-download";

export default {
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu,
  },
  data() {
    return {
      list: [],
      EmployeeStatus: LocalConstants.EmployeeStatus,
      tooltipType: null,
      filters: { status: LocalConstants.EmployeeStatus.ACTIVE.key },
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.EmployeeStatus.ACTIVE,
            LocalConstants.EmployeeStatus.INACTIVE
          ],
        },
        {
          label: "Área",
          key: "areaIds",
          type: Constants.TypeFilters.MULTIPLE,
          options: [],
        },
        {
          label: "Cargo",
          key: "roleIds",
          type: Constants.TypeFilters.MULTIPLE,
          options: [],
        },
        {
          label: "Fecha de Ingreso",
          key: "contractInitiation",
          type: Constants.TypeFilters.DATE,
          isRange: true
        },
        {
          label: "Fecha de Cese",
          key: "contractFinish",
          type: Constants.TypeFilters.DATE,
          isRange: true
        },
        // {
        //   label: "Vacaciones pendientes",
        //   key: "pending",
        //   type: Constants.TypeFilters.SINGLE,
        //   options: [
        //     LocalConstants.BooleanTypes.YES,
        //     LocalConstants.BooleanTypes.NO
        //   ],
        // },
        {
          label: "Empresa",
          key: "companyId",
          type: Constants.TypeFilters.SINGLE,
          options: [],
        }
      ],
    };
  },
  mixins: [PaginationMixin, FilterMixin],
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          page: this.page - 1,
          size: this.pageSize,
        };
        const data = { search: this.search, ...this.filters };
        const response = await EmployeeService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      let keyInt = parseInt(key)
      return Util.searchValue(keyInt, LocalConstants.EmployeeStatus);
    },
    companies(o) {
      const list = Array.isArray(o.contracts) ? o.contracts : []
      const names = list.map(c => c.companyName).filter(Boolean)
      return names.length ? names.join(', ') : '-'
    },
    areas(o) {
      const list = Array.isArray(o.contracts) ? o.contracts : []
      const names = list.map(c => c.areaName).filter(Boolean)
      return names.length ? names.join(', ') : '-'
    },
    positions(o) {
      const list = Array.isArray(o.contracts) ? o.contracts : []
      const names = list.map(c => c.positionName).filter(Boolean)
      return names.length ? names.join(', ') : '-'
    },
    getIdentifierType(key) {
      return Util.searchValue(key, LocalConstants.IdentifierType)
    },
    async getAreas() {
      try {
        this.$store.dispatch("app/loading", true);

        const resp = (await AreaService.listAll()).payload;

        let optionItem = this.filterOptions.find((item) => item.key === "areaIds");

        optionItem.options = resp.map((item) => {
          return {
            key: item.id,
            label: `${item.description}`,
          };
        });
      } catch (ex) {
        Alert.error(ex.errors.message);
        console.error(ex);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async getRoles() {
      try {
        this.$store.dispatch("app/loading", true);

        const resp = (await RolesService.listAll()).payload;

        let optionItem = this.filterOptions.find((item) => item.key === "roleIds");

        optionItem.options = resp.map((item) => {
          return {
            key: `${item.id}`,
            label: `${item.description}`,
          };
        });
      } catch (ex) {
        Alert.error(ex.errors.message);
        console.error(ex);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async getBusinesses() {
      try {
        this.$store.dispatch("app/loading", true);

        const resp = (await CompanyService.listAll()).payload;

        let optionItem = this.filterOptions.find((item) => item.key === "companyId");

        optionItem.options = resp.map((item) => {
          return {
            key: item.id,
            label: `${item.name}`,
          };
        });
      } catch (ex) {
        Alert.error(ex.errors.message);
        console.error(ex);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    }
    // openChangeStatus(supplierId, status) {
    //   const self = this;
    //   Alert.dialog(
    //     "¿Desea cambiar el estado del proveedor?",
    //     null,
    //     async function () {
    //       try {
    //         await self.$store.dispatch("app/loading", true);
    //         const resp = (
    //           await EmployeeService.changeStatus(supplierId, status)
    //         ).payload;

    //         const obj = self.list.find((o) => {
    //           return o.id === resp.id;
    //         });
    //         if (obj) {
    //           const index = self.list.indexOf(obj);
    //           self.$set(self.list, index, resp);
    //         }
    //         Alert.success("Estado actualizado correctamente");
    //       } catch (e) {
    //         console.error(e);
    //         Alert.error(e.errors.message);
    //       } finally {
    //         await self.$store.dispatch("app/loading", false);
    //       }
    //     }
    //   );
    // },
    // async downloadReport() {
    //   try {
    //     await this.$store.dispatch("app/loading", true);
    //     const data = { search: this.search, ...this.filters };
    //     const response = await EmployeeService.download(data);
    //     fileDownload(response.data, Util.getFileName(response));
    //   } catch (error) {
    //     console.error(error);
    //     Alert.error(error);
    //   } finally {
    //     await this.$store.dispatch("app/loading", false);
    //   }
    // },
  },
  async created() {
    await this.loadData(this.page, this.pageSize);
    await this.getAreas()
    await this.getRoles()
    await this.getBusinesses()
  },
};
</script>

<style lang="stylus">
</style>
